import React from 'react';

export const StyledCell  = ({cellContent}) =>
{   
    return<td><div className="d-flex align-items-center"><strong>{cellContent}</strong></div></td>
}